import { baseRoute } from '../components/common';

export const HOME_ROUTE = baseRoute;
export const SCHEDULE_ROUTE = `${baseRoute}/schedule`;

export const REGISTRATION_ROUTE = `${baseRoute}/registration`;
export const REGISTRATION_CONFIRM_ROUTE = `${baseRoute}/registration/:code`;
export const LOGIN_ROUTE = `${baseRoute}/login`;
export const FORGOT_PASSWORD_ROUTE = `${baseRoute}/forgot`;
export const RESET_PASSWORD_ROUTE = `${baseRoute}/reset/:code`;

export const CUSTOMER_ROUTE = `${baseRoute}/customer`;
export const CUSTOMER_ORDERS_ROUTE = `${baseRoute}/customer/orders`;

export const CART_ROUTE = `${baseRoute}/cart`;

export const CHECKOUT_ROUTE = `${baseRoute}/checkout`;
export const CHECKOUT_GIFT_ROUTE = `${baseRoute}/checkout/gift`;
export const CHECKOUT_CARD_ROUTE = `${baseRoute}/checkout/card`;
export const CHECKOUT_SUMMARY_ROUTE = `${baseRoute}/checkout/summary`;
export const CHECKOUT_SUMMARY_UPDATED_ROUTE = `${baseRoute}/checkout/summary-updated`;
export const CHECKOUT_CANCEL_ROUTE = `${baseRoute}/checkout/cancel`;
export const CHECKOUT_SUCCESS_ROUTE = `${baseRoute}/checkout/success`;

export const MAILING_SUBSCRIBE_ROUTE = `${baseRoute}/mailing/subscribe`;
export const MAILING_UNSUBSCRIBE_ROUTE = `${baseRoute}/mailing/unsubscribe`;
export const MAILING_UNSUBSCRIBED_ROUTE = `${baseRoute}/mailing/unsubscribed`;

export const POLICY_REFUND_ROUTE = `${baseRoute}/policy/refund`;

export const SHOW_ORDER_ROUTE = `${baseRoute}/show/:code`;
